import styled from 'styled-components';

export const Cabecalho = styled.div`
  display:flex;
  flex-direction:column;
  width:50%;
  background:#fff;
  padding:20px 20px 0 20px;
  margin:0 auto;
  >h3{
      margin:10px 0;
  }
  >p{
      margin-bottom:10px;
  }
  @media(max-width:800px){
      width:unset;
  }
`;

export const DadosPagamento = styled.form`
    display:flex;
    flex-direction:column;
    width:50%;
    background:#fff;
    padding:20px;
    margin:0 auto;
    >span{
        margin:10px 0;
        :first-child{
            margin:0 0 10px 0;
        }
    }
    >input{
        height:40px;
    }
    >div>input{
        height:40px;
    }

    @media(max-width:800px){
      width:unset;
  }
`
